import { useRouter } from '@application/utils';
import { useTranslation } from '@presentation/utils';
import { Form, useFormikContext } from 'formik';
import type { FC } from 'react';
import { Button } from '../Button';
import { InputCheckboxField } from '../InputCheckboxField';
import { InputField } from '../InputField';
import { InputLabel } from '../InputLabel';
import { InputWrapper } from '../InputWrapper';
import * as Styled from './styled';

export * from './types';

export const ContactForm: FC = () => {
  const { translate } = useTranslation();
  const { routeLocationDescriptor } = useRouter();
  const warningBoxText = translate('contact.warning');
  const { isSubmitting } = useFormikContext();

  return (
    <Form>
      <Styled.WarningBox
        dangerouslySetInnerHTML={{
          __html: warningBoxText
            .replace('$hrefAdoption', routeLocationDescriptor('breederList').pathname)
            .replace('$hrefPro', routeLocationDescriptor('proLanding').pathname),
        }}
      />
      <InputWrapper split>
        <InputLabel required>{translate('common.inputs.firstName.label')}</InputLabel>
        <InputField name="firstName" />
      </InputWrapper>

      <InputWrapper split last>
        <InputLabel required>{translate('common.inputs.lastName.label')}</InputLabel>
        <InputField name="lastName" />
      </InputWrapper>

      <InputWrapper>
        <InputLabel required>{translate('common.inputs.email.label')}</InputLabel>
        <InputField name="email" type="email" />
      </InputWrapper>

      <InputWrapper>
        <InputLabel>{translate('common.inputs.phone.label')}</InputLabel>
        <InputField name="phone" type="tel" />
      </InputWrapper>

      <InputWrapper>
        <InputLabel required>{translate('common.inputs.message.label')}</InputLabel>
        <InputField name="messageContent" textarea />
      </InputWrapper>

      <InputWrapper>
        <InputCheckboxField name="confirmedForm">
          {translate('contact.confirmedForm')}
        </InputCheckboxField>
      </InputWrapper>

      <Button type="submit" loading={isSubmitting} color="blue">
        {translate('common.buttons.send')}
      </Button>
    </Form>
  );
};
